import qs from 'qs';
import moment from 'moment';
import api from './api';
import generateSearchRequest from '../utils/sequelize-search-builder-client';

const selectOrder = (order) => {
	return {
		...order,
		createdAt: order.createdAt ? moment(order.createdAt).toDate() : null,
		updatedAt: order.updatedAt ? moment(order.updatedAt).toDate() : null,
		deliveryDate: order.deliveryDate ? moment(order.deliveryDate).toDate() : null,
	};
};

const selectOrders = (orders) => orders.map(selectOrder);

class OrderBtcService {
	getAll({ page = 0, size = 10, order, filters }) {
		//const _order = {};

		// for (const key in order) {
		// 	if (key === 'clientName') {
		// 		_order['client.name'] = order[key];
		// 	} else if (key === 'delivermanName') {
		// 		_order['deliverman.name'] = order[key];
		// 	} else {
		// 		_order[key] = order[key];
		// 	}
		// }

		//console.log('_order', _order);

		const settings = {
			where: {
				id: {
					as: 'id',
					type: 'like',
				},
				clientId: {
					as: 'clientId',
					type: 'equal',
				},
				packageType: {
					as: 'packageType',
					type: 'like',
				},
				packageSize: {
					as: 'packageSize',
					type: 'like',
				},
				trackingCode: {
					as: 'trackingCode',
					type: 'like',
				},
				status: {
					as: 'status',
					type: 'like',
				},
				clientName: {
					as: 'client.name',
					type: 'like',
				},
				baseName: {
					as: 'client.base.name',
					type: 'like',
				},
				baseId: {
					as: 'client.base.id',
					type: 'equal',
				},
				delivermanName: {
					as: 'deliverman.name',
					type: 'like',
				},
				'createdAt:between': {
					as: 'createdAt',
					type: 'between',
				},
			},
			order,
		};
		const request = generateSearchRequest(filters, settings);
		return api
			.get('/orders-btc', {
				paramsSerializer: {
					serialize: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
				},
				params: {
					page,
					size,
					...request,
				},
			})
			.then((response) => response.data)
			.then((data) => ({ ...data, body: selectOrders(data.body) }))
			.catch((error) => {
				console.log(
					`fail when trying to get ordersBtc in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	getById(id) {
		return api
			.get(`/orders-btc/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectOrder)
			.catch((error) => {
				console.log(
					`fail when trying to get orderBtc with id ${id} in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	getAccountantsByClientId(clientId) {
		return api
			.get(`/orders-btc/accountants/${clientId}`)
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					`fail when trying to get orderBtc accountants with client id ${clientId} in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	createMany(orderBtcForm) {
		return api
			.post('/orders-btc/demand', orderBtcForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectOrder)
			.catch((error) => {
				console.log(
					`fail when trying to create orderBtc in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	create(orderBtcForm) {
		return api
			.post('/orders-btc', orderBtcForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectOrder)
			.catch((error) => {
				console.log(
					`fail when trying to create orderBtc in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	finalize(id, orderBtcForm) {
		return api
			.post(`/orders-btc/${id}/finalize`, orderBtcForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectOrder)
			.catch((error) => {
				console.log(
					`fail when trying to finalize orderBtc with id ${id} in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	unfullfill(id, orderBtcForm) {
		return api
			.post(`/orders-btc/${id}/unfullfill`, orderBtcForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectOrder)
			.catch((error) => {
				console.log(
					`fail when trying to unfullfill orderBtc with id ${id} in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	getPackageSizes() {
		return api
			.get('/orders-btc/package-sizes')
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					`fail when trying to get package sizes in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	hasOrderByTrackingCode(trackingCode) {
		return api
			.head(`/orders-btc/tracking-code/${trackingCode}`)
			.then((response) => true)
			.catch((error) => {
				if (error.response?.status === 404) {
					return false;
				}
				console.log(
					`fail when trying to check if has order by tracking code in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	getOrderStatuses() {
		return api
			.get('/orders-btc/statuses')
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					`fail when trying to get order statuses in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	downloadCsv() {
		return api
			.get('/orders-btc/download')
			.then((response) => response.data)
			.then((data) => new Blob([data], { type: 'application/csv' }))
			.then((blob) => URL.createObjectURL(blob))
			.then((uril) => {
				let link = document.createElement('a');
				link.setAttribute('href', uril);
				link.setAttribute('download', 'pedidos-b2c.csv');
				let clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: false,
				});
				link.dispatchEvent(clickEvent);
			})
			.catch((error) => {
				console.log(
					`fail when trying to download csv in OrderBtcService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}
}

const orderBtcService = new OrderBtcService();
export default orderBtcService;
